// The workspace's own spend (#632, D6): what its runs used this period, and — only
// when it pays for itself — what its own line of its own bill comes to.
//
// Read off `routes/billing.py`. A workspace under an MSP reads credits and no
// currency amount (#469 P3): the payer is invoiced, and the customer sees only
// its own usage. A self-paying workspace reads its own line, priced.

import type { Api } from "./http";

export const SPEND_PATH = "/api/v1/billing/spend";
export const INVOICE_PATH = "/api/v1/billing/invoice";

/** One run's debit on the workspace's ledger, as `spend_for_workspace` answers it. */
export interface SpendRun {
  run_id: string;
  credits: number;
  at: string;
}

/** One chat turn's debit (#670): a turn asked on a run, priced from its own counts. */
export interface SpendChatTurn {
  run_id: string;
  turn_id: string;
  credits: number;
  at: string;
}

/** The workspace's own line of its own bill, present only when it pays for itself. */
export interface SpendBill {
  currency: string;
  fee: string;
  included_credits: number;
  overage_credits: number;
  overage: string;
  total: string;
  stand_ins: string[];
}

export interface SpendView {
  period: string;
  /** True when the workspace's payer is its owning org: its own bill, not an MSP's. */
  paid_by_own_organisation: boolean;
  credits_used: number;
  cap_credits: number | null;
  runs: SpendRun[];
  /** Beside the runs, so the listed items add up to `credits_used`. */
  chat_turns: SpendChatTurn[];
  /** Absent when an MSP pays: a customer under one sees no currency amount. */
  bill?: SpendBill;
}

export const readSpend = (api: Api): Promise<SpendView> => api.get<SpendView>(SPEND_PATH);
